import React, { useState } from "react";
import axios from "axios";
import { endpoints } from "../apiConfig";
import { colors, fonts, space, radius, buttonPrimary, inputBase } from "../theme";

export function ContactSupportModal({ onClose, prefillEmail }) {
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await axios.post(endpoints.contactSupport, { message }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` },
      });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong. Please try again.");
    }
  };

  return (
    <Modal onClose={onClose} title="Contact Support">
      {sent ? (
        <p style={styles.modalText}>Thank you. Your message was sent. Our team will be in touch shortly.</p>
      ) : (
        <form onSubmit={submit} style={styles.form}>
          {prefillEmail && <input style={styles.input} value={prefillEmail} disabled />}
          {error && <div style={styles.error}>{error}</div>}
          <textarea
            style={{ ...styles.input, height: 100 }}
            placeholder="How can we help?"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
          <button style={styles.button} type="submit">Send</button>
        </form>
      )}
    </Modal>
  );
}

export function SetupModal({ onClose }) {
  return (
    <Modal onClose={onClose} title="Quick Setup Guide">
      <ol style={{ paddingLeft: 18, lineHeight: 1.7, fontFamily: fonts.body, color: colors.textPrimary }}>
        <li>Log in with the credentials from your approval email.</li>
        <li>Add your menu categories and items under <strong>Menu</strong>.</li>
        <li>Set up your tables under <strong>Tables</strong>.</li>
        <li>Add your team under <strong>Staff</strong>.</li>
        <li>Watch live activity on your <strong>Dashboard</strong> while using the app.</li>
      </ol>
    </Modal>
  );
}

function Modal({ title, children, onClose }) {
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.modalHeader}>
          <strong style={{ fontFamily: fonts.display }}>{title}</strong>
          <button style={styles.closeBtn} onClick={onClose}>×</button>
        </div>
        <div style={{ padding: space[4] }}>{children}</div>
      </div>
    </div>
  );
}

const styles = {
  form: { display: "flex", flexDirection: "column", gap: space[3] },
  input: inputBase,
  button: buttonPrimary,
  overlay: {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 1000,
  },
  modal: { width: 360, maxWidth: "calc(100vw - 24px)", background: colors.surface, borderRadius: radius.md, overflow: "hidden" },
  modalHeader: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    padding: `${space[3]} ${space[4]}`, borderBottom: `1px solid ${colors.border}`,
  },
  closeBtn: { background: "none", border: "none", fontSize: 20, cursor: "pointer" },
  modalText: { fontFamily: fonts.body, color: colors.textPrimary },
  error: { color: "#b91c1c", fontSize: 13, fontFamily: fonts.body },
};
